export { UiBannerPicture } from './UiBannerPicture';
